<template>
  <div class="bg-light pb-2 overflow-auto h-100">
      <header class="p-3 bg-white d-flex flex-row justify-content-between align-items-center mb-1 perfheader">
          <h5 class="m-0 fw-700">{{(Object.keys(data).length ? 'Comparative Performance MTD' : '')}}</h5>
          <div class="d-flex flex-row">
              <select class="form-select fw-600 text-muted me-2 w-auto" v-model="filter.m">
                  <option :value="month" v-for="month in 12" :key="month">{{format('2020-'+month+'-1')}}</option>
              </select>
              <select class="form-select fw-600 text-muted" v-model="filter.y">
                  <option :value="year(i)" v-for="i in 3" :key="i">{{year(i)}}</option>
              </select>
          </div>
      </header>
      <div v-if="Object.keys(data).length > 0 && !data_loading" class="p-3">
          <div class="card" v-for="(d, index) in data" :key="index">
            <div class="card-body p-0">
                <h5 class="card-title p-3 m-0 fw-600 opacity-8" style="background: #e2e2e2; color: #000 !important;">{{d.title}}</h5> 
                <div class="table-responsive">
                    <table class="table table-hover m-0 position-relative h-100 table-sm sortable">
                        <thead>
                            <th class="text-black px-2 py-3 border-top border-bottom bg-light fw-500 fs-13" :class="{'text-end':hindex > 0}" v-for="(h, hindex) in d.headings" :key="hindex" @click="sort(index, hindex)">
                                {{h}}
                                <i class="mdi" :class="{'mdi-chevron-down':!asc[index] && (typeof sort_key[index] !== undefined ? sort_key[index] : -1) == hindex, 'mdi-chevron-up':asc[index] && (typeof sort_key[index] !== undefined ? sort_key[index] : -1) == hindex}"></i>
                            </th>
                        </thead>
                        <tbody v-if="d.body.length && !data[index].loading">
                            <tr class="cp" v-for="(b, bindex) in d.body" :key="bindex" @click="openPerformance($event)">
                                <td v-for="(bd, bdindex) in b" :key="bdindex" class="px-4 border-bottom py-1" :class="colorCondition(d, b, bdindex)">
                                    <div v-html="bd" v-if="bdindex == 0"></div>
                                    <span class="text-nowrap fs-13 text-muted fw-400" v-else>{{bd}}</span>
                                </td>
                            </tr>
                        </tbody>
                        <div class="position-relative d-flex w-100 h-100 flex-column text-muted p-3 text-nowrap" v-else-if="data[index].loading">
                            Loading ...
                        </div>
                        <div class="position-relative d-flex w-100 h-100 flex-column text-muted p-3 text-nowrap" v-else>
                            No data found
                        </div>
                    </table>
                </div>
            </div>
          </div>
      </div>
      <div class="d-flex flex-column justify-content-center align-items-center bg-white w-100 opacity-3" style="height: 79vh" v-else>
            <i class="mdi mdi-chart-box-outline h-auto" style="font-size: 100px;"></i>
            <span class="fw-500">Data is being generated</span>
        </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
    data() {
        return {
            filter: {
                m: moment().format('M'),
                y: moment().format('YYYY')
            },
            data: {},
            data_loading: false,
            asc: {},
            sort_key: {},
            temp: [],
        }
    },
    methods: {
        compare(a, b) {
            if (a === b) {
                return 0;
            }
            return a > b ? -1 : 1;
        },
        sort(index, hindex) {
              
            this.asc[index] = !this.asc[index];
            this.sort_key[index] = hindex;
            
            
            this.data[index].body = this.temp[index]; 

            setTimeout(() => {
                //RESET BODY
                const list = this.data[index].body.slice(); 
                list.sort((a, b) => {
                    function getValue(s) { 
                        var number = Number(s.replace(/[^0-9.-]+/g,""));
                        return number; 
                    }

                    a = a[hindex];
                    b = b[hindex];

                    if(hindex == 0) {
                        let div = new DOMParser().parseFromString(a, 'text/html');
                        let name = div.getElementsByTagName('h5');
                        if(name[0] !== undefined && name[0] !== null) {
                            a = name[0].textContent.toString().toLowerCase();
                            b = name[0].textContent.toString().toLowerCase();
                        }
                        return (this.asc[index] ? (a > b ? 1 : -1) : (a > b ? -1 : 1));
                    }
                    else {
                        a = getValue(a);
                        b = getValue(b);
                        return (this.asc[index] ? a - b : b - a);
                    }

                    
                });
                this.data[index].body = list;
            }, 5);
        },
        year(minus = 0) {
            minus -= 1;
            return moment().subtract(minus, "years").format('YYYY');
        },
        format(date = '') {
            return moment(new Date(date)).format('MMMM');
        },
        open(index) {
            this.$router.push(`/performance/${index}`);
        },
        async load() {
            this.data = {};
            this.data_loading = true;
            await this.$axios.get('/performance')
                    .then((res) => {
                        if(res.status == 200) {
                            if(typeof res.data === 'object') this.data = res.data;
                            else this.$router.replace(encodeURI(res.data));
                        }
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    });
            this.data_loading = false;
        },
        async loadTable(type) {
            this.data[type].body = [];
            this.data[type].loading = true;
            await this.$axios.post(`/performance/${type}`, this.$qs.stringify(this.filter))
                    .then((res) => {
                        if(res.status == 200) {
                            this.data[type].body = res.data;
                            this.temp[type] = res.data;
                        }
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    })
            this.data[type].loading = false;
        },
        loadAll() {
            if(Object.keys(this.data).length) {
                for(var key in this.data) {
                    this.loadTable(key);
                }
            }
        },
        openPerformance(e) {
            if(e.target.tagName === 'BUTTON') return;
            let target = e.target.closest('tr');
            let iddoc = target.querySelector('div[data-id]');
            let typedoc = target.querySelector('div[data-type]');

            let id = iddoc.getAttribute('data-id');
            if(typedoc !== null) this.$router.push(`/${typedoc.getAttribute('data-type')}/${id}?m=${this.filter.m}&y=${this.filter.y}`);

            else this.$router.push(`/performance/${id}`);
        },
        recordScroll(e) {
            localStorage.setItem('versatechvex_scroll', e.target.scrollTop);
        },
        colorCondition(main, b, row_index) {
            let classname = '';
            if(main.hasOwnProperty.call(main, 'color_condition')) {
                if (main.color_condition.length) {
                    main.color_condition.forEach(element => {
                        if(element === row_index) {
                            let int = parseInt(b[element]);
                            if(int >= 100) classname = 'bg-success text-white';
                            else if(int >= 80) classname = 'bg-warning text-white';
                        }
                    });
                }
            }

            return classname;
        }
    },
    activated() {
        if(Object.keys(this.data).length <= 0) this.load();

        
        let scrl = document.getElementsByClassName('main');
        if(scrl[0] !== undefined) {
            let savedScroll = localStorage.getItem('versatechvex_scroll');
            if(!isNaN(savedScroll)) {
                scrl[0].scrollTop = savedScroll;
            }

            scrl[0].addEventListener('scroll', this.recordScroll);
        }
    },
    deactivated() {
        let scrl = document.getElementsByClassName('main');
        if(scrl[0] !== undefined) {
            scrl[0].removeEventListener('scroll', this.recordScroll);
        }
    },
    watch: {
        "data": function() {
            this.loadAll();
        },
        "filter.y": function() {
            this.loadAll();
        },
        "filter.m": function() {
            this.loadAll();
        }
    }
}
</script>

<style scoped>
.text-primary {
    color: var(--primary-color) !important;
}

th:first-child {
    text-align: left;
}

td {
    vertical-align: middle;
    text-align: right;
}

.table>:not(:last-child)>:last-child>* {
    border-bottom-color: #ececec;
}

.card {
    margin-bottom: 10px;
}

.perfheader {
    position: sticky;
    top: 0;
    z-index: 999;
}

.bg-success span {
    color: #fff !important;
}
</style>